import { render } from "./PlayView.vue?vue&type=template&id=51b56c98"
import script from "./PlayView.vue?vue&type=script&lang=js"
export * from "./PlayView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__